import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import BackButton from '@/components/Buttons/BackButton';
import DynamicPage from '@/components/DynamicPage/DynamicPage';
import PAGE_IDS from '@/consts/pageIds';
import useHideMenu from '@/hooks/useHideMenu';
import {trackBadgesInProgressViewed} from '@/services/events/loyaltyEventTracking';
import appRouterService from '@/services/route/appRouterService';
import {selectInProgressBadges} from '@/state/selectors/loyalty';

const InProgressPage = ({isActive}: {isActive: boolean}) => {
    const inProgressBadges = useSelector(selectInProgressBadges);

    useHideMenu(isActive);

    // If a refetch (e.g. after returning from an external link) leaves no
    // in-progress badges, this page has nothing meaningful to show — go back.
    // Guard: only act when this slide is active — the component is always
    // mounted inside the Swiper.
    useEffect(() => {
        if (isActive && inProgressBadges.length === 0) {
            appRouterService.goBack();
        }
    }, [isActive, inProgressBadges.length]);

    // The slide is always mounted inside the Swiper — track only when visible.
    useEffect(() => {
        if (isActive) {
            trackBadgesInProgressViewed(inProgressBadges.map((badge) => badge.title));
        }
    }, [isActive, inProgressBadges]);

    return (
        <div className='flex h-auto flex-col'>
            <BackButton onClick={appRouterService.goBack} className='mt-app-4 ml-4 shrink-0' />
            <DynamicPage pageId={PAGE_IDS.IN_PROGRESS} className='min-h-0 flex-1 pb-app-4' />
        </div>
    );
};

export default InProgressPage;
